export default "__VITE_ASSET__DMETpOes__"